import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Same Firebase project — do not replace these credentials.
const firebaseConfig = {
  apiKey: 'AIzaSyA9rhSf6g51Uumqc2l0Yp4cYb5ZtSnB7Ek',
  authDomain: 'artificiallly.firebaseapp.com',
  projectId: 'artificiallly',
  storageBucket: 'artificiallly.firebasestorage.app',
  messagingSenderId: '675717749514',
  appId: '1:675717749514:web:b8e1341c96a0dac69d38f3',
  measurementId: 'G-95SXN4LLM4',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
